// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__11ZSG","select":"Header_select__1t00c","clinic":"Header_clinic__z45tA"};